import{useContext as t}from"react";import o from"./context";/**
 * React hook for getting AuthContext value
 *
 * @example
 *    const { isAuthenticated, login, logout } = useAuth()
 */const r=()=>{const r=t(o);return r};export default r;